<template>
  <Expandable header="Alternate Family Contact" class="mb-10">
    <template v-slot:action>
      <create
        :list="list"
        v-if="!isDisabled && isAdd"
        @onCreate="onCreate"
      ></create>
    </template>
    <b-table
      class="mt-3"
      :fields="headers"
      :items="list"
      responsive
      :head-variant="'dark'"
      thead-class="table-light"
    >
      <template #cell(contact_id)="{ item }">
        {{ getContactType(item) }}
      </template>
      <template #cell(first_name)="{ item }">
        {{ `${item.first_name} ${item.last_name}` }}
      </template>
      <template #cell(action)="{ item, index }">
        <template v-if="!isDisabled">
          <div class="d-flex" v-if="item.status != 4">
            <create
              :list="list"
              :item="item"
              :index="index"
              @onUpdate="onUpdate"
            ></create>
            <delete-button @click="remove(index)"> </delete-button>
          </div>
          <div class="d-flex" v-else>
            <b-button pill variant="danger" @click="undo(index)" size="sm"
              >undo remove</b-button
            >
          </div>
        </template>
      </template>
    </b-table>

    <!-- Phase 2 - Patient Consent OTP (US-005) -->
    <ConsentOTP
      v-if="recipientId"
      consentType="PATIENT"
      referenceType="RECIPIENT"
      :referenceId="recipientId"
      :phoneNumber="primaryPhone"
      :disabled="isDisabled"
      @consent-verified="$emit('consent-verified', $event)"
    />
  </Expandable>
</template>

<script>
import { RECIEPIENT_MASTER_TYPE } from "../../../assets/js/common";
import { FIELD } from "../../../assets/js/rules";
import DeleteButton from "../../buttons/DeleteButton.vue";
import Expandable from "../../Expandable.vue";
import Create from "./contact/RecipientContactCreate.vue";
import ConsentOTP from "../../consent/ConsentOTP.vue";
export default {
  props: {
    value: Array,
    isDisabled: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 3,
    },
    recipientId: {
      type: [Number, String],
      default: 0,
    },
  },
  components: { Expandable, Create, DeleteButton, ConsentOTP },
  data() {
    return {
      rules: FIELD,
      files: [],
      list: [],
    };
  },
  computed: {
    contactTypes() {
      return this.masterContactTypes.filter((item) => {
        return item.contact_type == RECIEPIENT_MASTER_TYPE;
      });
    },
    isAdd() {
      let count = this.count;
      const vm = this;
      let list = vm.list.filter((item) => {
        return item.status == 1;
      });
      return list.length != count;
    },
    headers() {
      let doc = {
        first_name: "Name",
        phone_number_1: "Phone",
        contact_id: "Role",
        email_id: "Email",
        action: "Action",
      };
      let list = [];
      Object.keys(doc).forEach((key) => {
        list.push({
          label: doc[key],
          key,
        });
      });
      return list;
    },
    isUpdate() {
      let { name } = this.$route;
      return name == "update-hospital" || "update-transplant-license";
    },
    primaryPhone() {
      if (!this.list || !this.list.length) return "";
      let active = this.list.find((item) => item.status == 1 && item.phone_number_1);
      return active ? active.phone_number_1 : "";
    },
  },
  methods: {
    getContactType({ contact_id }) {
      let item = this.contactTypes.find((item) => {
        return item.value == contact_id;
      });
      return item instanceof Object ? item.name : "";
    },
    undo(i) {
      this.list[i].status = 1;
    },
    remove(i) {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure?",
        onConfirm: () => {
          if (vm.list[i].hospital_contact_id) {
            vm.list[i].status = 4;
          } else {
            vm.list.splice(i, 1);
          }
        },
      });
      vm.$emit("input", vm.list);
    },
    onCreate(item) {
      const vm = this;
      vm.list.unshift(item);
      vm.$emit("input", vm.list);
    },
    onUpdate({ doc, index }) {
      const vm = this;
      vm.$set(vm.list, index, doc);
      vm.$emit("input", vm.list);
    },
  },
  mounted() {
    this.list = this.value;
  },
};
</script>

<style></style>
